<template>
  <div class="mycollect">
    <van-nav-bar
    v-if="source==1"
    title="我的收藏"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-tabs v-model="active" title-active-color="#F6AB00" color="#F6AB00" :style="{'margin-top':source==1?'45px':'0'}" @click="onClick" sticky>
      <van-tab title="资讯收藏">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
        >
        <div slot="loading" class="list-loading">
          <img :src="this.img.loading" />
          <span>正在刷新</span>
        </div>
        <div class="list-box" v-for="item in list" :key="'list_' + item.id">
          <div v-if="item.module.id==1">
            <router-link :to="{name: 'ContentPostShow', params: {id: item.id}}">
              <van-row gutter="15">
                <van-col span="8">
                  <img class="picone" :src="item.pic_url">
                </van-col>
                <van-col class="listitle ellipsis-2" span="16">
                  {{ item.title }}
                  <van-tag plain type="danger" v-if="item.label!=null">{{item.label.name}}</van-tag>
                </van-col>
              </van-row>
            </router-link>
            <van-row type="flex" justify="space-between">
              <van-col span="14">
                <span class="sourtime">{{item.media.name}}  {{item.time_format}}</span>
              </van-col>
              <van-col class="bintright" span="10">
                <span class="">
                  <img class="binpic" :src="img.comment">
                  <span class="sourtime">{{item.reply_num}}</span>
                </span>
                <span class="binbox">
                  <img class="binpic" :src="img.parise">
                  <span class="sourtime">{{item.praise}}</span>
                </span>
              </van-col>
            </van-row>
          </div>
          <div v-if="item.module.id==2">
            <div class="listitle ellipsis-2">
              <router-link :to="{name: 'ContentPicShow', params: {id: item.id}}">
                {{ item.title }}
                <van-tag plain type="danger" v-if="item.label!=null">{{item.label.name}}</van-tag>
              </router-link>
            </div>
            <div class="pic-box" v-if="item.pics.length<3&&item.pics.length>0">
              <router-link :to="{name: 'ContentPicShow', params: {id: item.id}}">
                <img class="pic_thumb" fit="cover" :src="item.pics[0].img_url">
              </router-link>
            </div>
            <div class="pic" v-if="item.pics.length==3">
              <router-link :to="{name: 'ContentPicShow', params: {id: item.id}}">
                <van-row gutter="5">
                  <van-col span="16">
                    <img v-if="item.pics && item.pics[0].img_url" v-lazy="item.pics[0].img_url" />
                  </van-col>
                  <van-col span="8">
                    <img v-if="item.pics && item.pics[1].img_url" v-lazy="item.pics[1].img_url" class="right one" />
                    <img v-if="item.pics && item.pics[2].img_url" v-lazy="item.pics[2].img_url" class="right" />
                  </van-col>
                </van-row>
              </router-link>
            </div>
            <van-row type="flex" justify="space-between">
              <van-col span="14">
                <span class="sourtime">{{item.media.name}}  {{item.time_format}}</span>
              </van-col>
              <van-col class="bintright" span="10">
                <span class="">
                  <img class="binpic" :src="img.comment">
                  <span class="sourtime">{{item.reply_num}}</span>
                </span>
                <span class="binbox">
                  <img class="binpic" :src="img.parise">
                  <span class="sourtime">{{item.praise}}</span>
                </span>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </van-tab>
    <van-tab title="帖子收藏">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="this.img.loading" />
        <span>正在刷新</span>
      </div>
      <div class="list-box" v-for="item in blist" :key="'blist_' + item.id">
        <van-row type="flex" justify="space-between">
          <van-col span="4">
            <img class="listhand" :src="item.user.headimg_url">
          </van-col>
          <van-col span="16">
            <div class="membername">
              {{item.user.user_name}}
            </div>
            <div class="sourtime">
              {{item.time_format}}  浏览 {{item.show_num}}
            </div>
          </van-col>
          <van-col class="bintright" span="4">
            <!-- <van-button color="#F6AB00" size="small" plain round>关注</van-button> -->
          </van-col>
        </van-row>
        <div class="listitle ellipsis-2">{{item.title}}</div>
        <div class="f-14 ellipsis-2"><span class="c-blue" v-if="item.tags.length>0">#{{item.tags[0].name}}#</span>{{item.content}}
        </div>
        <router-link :to="{name: 'BbsShow', params: {id: item.id}}">
          <div class="c-blue f-14 text-r">查看全部</div>
        </router-link>
        <div class="pic-box" v-if="item.image.length<3&&item.image.length>0">
          <img class="pic_thumb" v-lazy="item.image[0]">
        </div>
        <div class="pic" v-if="item.image.length==3">
          <van-row gutter="5">
            <van-col span="16">
              <img v-if="item.image && item.image[0]" v-lazy="item.image[0]" />
            </van-col>
            <van-col span="8">
              <img v-if="item.image && item.image[1]" v-lazy="item.image[1]" class="right one" />
              <img v-if="item.image && item.image[2]" v-lazy="item.image[2]" class="right" />
            </van-col>
          </van-row>
        </div>
        <van-grid :border="false" :column-num="3" v-if="item.image.length>3">
          <van-grid-item v-for="(itemd, index) in item.image" :key="'imglist_' + index">
            <van-image  height="88px" radius="5" fit="cover" :src="itemd" />
          </van-grid-item>
        </van-grid>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <van-tag color="#F6AB00" round>{{item.channel.alias}}</van-tag>         
          </van-col>
          <van-col class="bintright" span="10">
            <span class="">
              <img class="binpic" :src="img.comment">
              <span class="sourtime">{{item.comment_num}}</span>
            </span>
            <span class="binbox">
              <img class="binpic" :src="img.parise">
              <span class="sourtime">{{item.praise_num}}</span>
            </span>
          </van-col>
        </van-row>
      </div>
    </van-list>
  </van-tab>
  <van-tab title="问答收藏">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    :immediate-check="false"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
      <span>正在刷新</span>
    </div>
    <div class="list-box" v-for="item in alist" :key="'alist_' + item.id">
      <van-row>
        <van-col span="2">
          <img class="quespic" :src="img.question">
        </van-col>
        <van-col span="22">
          <div class="listitle ellipsis-2">
            {{ item.question }}
          </div>
        </van-col>
      </van-row>
      <div class="f-14">
        {{ item.content }}
      </div>
      <div class="pic-box" v-if="item.image">
        <img class="pic_thumb" fit="cover" :src="item.image">
      </div>
      <van-row type="flex" justify="space-between">
        <van-col span="14">
          <span class="sourtime">{{item.answer_num}}个回答  {{item.collect_num}}个收藏</span>
        </van-col>
        <van-col class="bintright" span="10">
          <van-button icon="edit" color="#33A1FF" round size="small">我要回答</van-button>
        </van-col>
      </van-row>
    </div>
  </van-list>
</van-tab>
<!-- <van-tab title="商城">商城</van-tab> -->
</van-tabs>
</div>
</template>
<script>
 import list from '../../../api/member/mycollect';
 import { mapState } from 'vuex';
 import { Tab, Tabs, List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,NavBar} from 'vant'
 export default {
  data(){
    return{
      active: 0,
      list: [],
      blist:[],
      alist:[],
      page:1,
      channel_id:'',
      user_id:'',
      loading: false,
      finished: false,
      num:10,
      img: {
       parise: require('../../../assets/img/parise.png'),
       parise_have: require('../../../assets/img/parise_have.png'),
       comment: require('../../../assets/img/comment.png'),
       listimg: require('../../../assets/img/member/integral_bg.png'),
       avatar: require('../../../assets/img/default.jpg'),
       question: require('../../../assets/img/question.png'),
       answer: require('../../../assets/img/answers.png'),
       loading: require('../../../assets/img/loading.gif')
     }
   }
 },
 computed: {
  ...mapState({
    source: state => state.param.source
  })
},
created () {
  this.$store.commit('param/show', false)
  if(!Lockr.get('token')) {

    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
    }

    this.$toast('请先登录')
    return false
  }
  if(this.source == 3||this.source == 7) {
    this.$appService.isShowReturn({state: true})
  }
  
  let params={
    media_id:"",
    page:this.page,
  }
  this.getCollects(params)
  var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
},
methods: {
  onClick(name){
    if(name==0){
      this.list=[]
      this.page=1
      let params={
       media_id:"",
       page:1
     }
     this.getCollects(params)
   }else if(name==1){
    this.blist=[]
    this.page=1
    let params={
      media_id:"",
      page:1
    }
    this.getbbsCollects(params)
  }else{
    this.alist=[]
    this.page=1
    let params={
      media_id:"",
      page:1
    }
    this.getaskCollects(params)
  }
},
getCollects(params){
  list.getCollects(params).then(res => {
    if(res.data.state == 1) {
      let list=this.list
      let newlist=res.data.data.data
      if(list.length==0){
        this.list = res.data.data.data
      }else{
        this.num=newlist.length
        this.list = this.list.concat(newlist)
      }
    }
  })
},
getbbsCollects(params){
  list.getbbsCollects(params).then(res => {
    if(res.data.state == 1) {
      let blist=this.blist
      let newlist=res.data.data.data
      if(blist.length==0){
        this.blist = res.data.data.data
      }else{
        this.num=newlist.length
        this.blist = this.blist.concat(newlist)
      }
    }
  })
},
getaskCollects(params){
  list.getaskCollects(params).then(res => {
    if(res.data.state == 1) {
      let alist=this.alist
      let newlist=res.data.data.data
      if(alist.length==0){
        this.alist = res.data.data.data
      }else{
        this.num=newlist.length
        this.alist = this.alist.concat(newlist)
      }
    }
  })
},
onClickLeft(){
  this.$router.go(-1)
},
onLoad() {
      // 异步更新数据
      setTimeout(() => {
        let num=this.num
        if (num <10) {
          this.finished = true
          this.loading = false
        }else{
          this.page=this.page+1
          let params={
            media_id:"",
            page:this.page
          }
          if(this.active==0){
            this.getCollects(params)
          }else if(this.active==1){
            this.getbbsCollects(params)
          }else{
            this.getaskCollects(params)
          }
          this.loading = false
        }
      }, 500);
    },
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]: List,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [Image.name]:Image,
    [Icon.name]:Icon,
    [NavBar.name]:NavBar
  }
}
</script>

<style lang="scss">

.mycollect{
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .list-box{
    padding: 15px;
    border-bottom: 1px solid #f8f8f8;
    a {
      padding: 0;
      color: #3A3A3A;
    }
    .picone{
      width:100%;
      height:105px;
      border-radius:5px;
      object-fit: cover;
    }
    .listitle{
      font-size: 16px;
      font-weight:bold;
      line-height: 1.8;
      letter-spacing: 1.4px;
    }
    .sourtime{
      font-size:14px;
      color:rgba(154,154,154,1);
    }
    .bintright{
      text-align:right;
      .binbox{
        margin-left:20px;
      }
      .binpic{
        width:15px;
        height:14px;
        margin-right:8px;
      }
    }
    .pic-box {
      padding: 10px 0 10px 0 !important;
      height: 210px !important;
      .pic_thumb{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .pic {
      img {
        width: 100%;
        height: 205px;
        object-fit: cover;
        display: block;
        border-radius: 3px;

        &.right {
          height: 100px;
        }
        &.one {
          margin-bottom: 5px;
        }
      }
      .pic-grid{
        width: 33.33%;
        float: left;
        padding: 5px;
        box-sizing:border-box;
        height: 100px;
      }
    }
    .listhand{
      width:45px;
      height:45px;
      border-radius:30px;
    }
    .membername{
      font-size: 15px;
      font-weight: bold;
    }
    .van-tag{
      padding: 0 .5em;
    }
    .quespic{
      width: 22px;
      height: 22px;
    }
    .van-grid-item__content{
      padding: 5px 5px;
    }
  }
}
</style>
